

import {icon1,icon2,icon3,icon4,icon5,icon6 } from "../Helper/svgs";

const wgycData = [
    {
        icon: icon1,
        title: 'Manage and create you portfolio with us',
        content: ''
    },
    {
        icon: icon2,
        title: 'Diversifying your liquid assets to higher returns',
        content: ''
    },
    {
        icon: icon3,
        title: 'Weekly stocks recommendation with higher returns',
        content: ''
    },
    {
        icon: icon4,
        title: 'Personal Relationship Manager',
        content: ''
    },
    {
        icon: icon5,
        title: 'Get higher leverage for trading',
        content: ''
    },
    {
        icon: icon6,
        title: 'Access to advance training program',
        content: ''
    },
   
]

export default wgycData;